const toInputUppercase = (e) => {
	e.target.value = `${e.target.value}`.toUpperCase();
};

export { toInputUppercase };
